import React from "react";
import styles from "../AccountTable.module.css";
import { AES } from "crypto-js";
import { Link } from "react-router-dom";
import { Center, Grid, GridItem } from "@chakra-ui/react";
import { IAccount } from "../../../types/account";
import { get } from "lodash";

interface props {
  props: IAccount;
  index: number;
}

const ShowAccountsData: React.FC<props> = ({ props, index }) => {
  const normalToken =
    process.env.REACT_APP_AES_KEY !== undefined
      ? AES.encrypt(
          props._id.toString(),
          process.env.REACT_APP_AES_KEY
        ).toString()
      : props._id.toString();
  const token = window.btoa(normalToken);
  return (
    <div className={styles.userMainDiv}>
      <div className={styles.userProfile}>
        <p className={styles.indexNumber}>{index + 1}</p>

        <div
          className={
            //@ts-ignore
            props.user.isPro ? styles.proProfileDetail : styles.profileDetail
          }
        >
          <div className={styles.userNames}>
            <Grid templateColumns="repeat(5, 1fr)" gap={1}>
              <Center>
                <GridItem colSpan={1} h="auto" className={styles.particularDiv}>
                  <img
                    className={styles.profileImage}
                    src={
                      get(props, "profileImage.url")
                        ? get(props, "profileImage.url")
                        : "/Images/profile.png"
                    }
                    alt={props.firstName + props.lastName}
                  ></img>
                </GridItem>
              </Center>
              <GridItem colSpan={3} h="auto">
                <Grid
                  // templateRows='repeat(1, 1fr)'
                  templateColumns="repeat(1, 1fr)"
                  gap={0}
                >
                  <GridItem colSpan={1}>
                    <Grid
                      templateColumns="repeat(3, 1fr)"
                      fontWeight="bold"
                      gap={2}
                    >
                      <GridItem className={styles.mainText}>
                        {props.firstName}
                      </GridItem>
                      <GridItem className={styles.mainText}>
                        {props.lastName}
                      </GridItem>
                      <GridItem
                        className={styles.mainText}
                        m="0px 0px 0px 10px"
                      >
                        {props.views}
                      </GridItem>
                    </Grid>
                  </GridItem>
                  <GridItem
                    className={styles.mainText}
                    colSpan={2}
                    fontWeight="500"
                    fontSize="12px"
                    mt="2px"
                  >
                    {"Email: " + get(props, "user.email")}
                  </GridItem>
                </Grid>
              </GridItem>
              <Center>
                <GridItem colSpan={1} h="auto">
                  <Link to={`account_details/${token}`}>
                    <div className={styles.viewBtn}>
                      <button className={styles.view}>View</button>
                    </div>
                  </Link>
                  {
                    //@ts-ignore
                    props.user.isPro ? (
                      <p className={styles.proShow}>Pro</p>
                    ) : (
                      ""
                    )
                  }
                </GridItem>
              </Center>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowAccountsData;
